import { useAuth } from "@/core/auth/AuthProvider";
import { Button } from "@heroui/react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/403")({
	component: RouteComponent,
});

// The header (and its logout) is not rendered here, so this page carries its
// own way out — and a way to pick up permissions granted since login.
function RouteComponent() {
	const { refresh, logout } = useAuth();
	const navigate = useNavigate();

	const reloadAccess = async () => {
		await refresh();
		navigate({ to: "/admin/dashboard", replace: true });
	};

	const signOut = async () => {
		await logout();
		navigate({ to: "/login", search: { redirect: "" }, replace: true });
	};

	return (
		<div className="flex h-screen w-screen flex-col items-center justify-center gap-6 overflow-hidden bg-default-50">
			<div className="flex flex-col items-center gap-2">
				<span className="font-bold text-4xl">403</span>
				<span className="text-default-500">You can't open this page.</span>
			</div>
			<div className="flex gap-2">
				<Button variant="flat" onPress={reloadAccess}>
					Reload Access
				</Button>
				<Button color="danger" variant="flat" onPress={signOut}>
					Sign Out
				</Button>
			</div>
		</div>
	);
}
